import { FormComponent } from "@shared/features/form/Form";
import {
  QuizQuestionInputConfig,
  QuizQuestionInputType,
  QuizQuestionInputValidationRules,
  QuizQuestionChoice,
} from "@platform/types/quiz.types";

export const mapQuestionTypeToComponentAndProps = (
  choices: QuizQuestionChoice[],
  type: QuizQuestionInputType,
  config_object: QuizQuestionInputConfig,
  validation_rules: QuizQuestionInputValidationRules
): { component: FormComponent; props: object } => {
  let component: FormComponent = "Input";

  let props = {};

  const options = choices.map((choice) => ({
    label: choice.display_text,
    value: choice.id,
    description: choice.display_description,
  }));

  switch (type) {
    case "yes/no":
      component = "YesNoButtons";

      props = {
        ...props,
        options,
        isCustomComponent: true,
      };

      if (config_object.force_yes) {
        component = "ForceYesInput";

        props = {
          ...props,
          isForceYes: true,
        };
      }
      break;
    case "text input":
      component = "Input";
      props = {
        ...props,
        placeholder: config_object.placeholder || "Enter your answer here",
      };
      break;
    case "multiple choice":
      if (
        config_object.display_type === "select" ||
        config_object.display_type === "cloud"
      ) {
        component =
          config_object.display_type === "select" ? "Select" : "SelectChips";
      } else {
        component = "RadioGroup";
      }

      props = {
        ...props,
        options,
        displayType: config_object.display_type,
        maxItems:
          validation_rules.max_select === "none"
            ? undefined
            : validation_rules.max_select,
        isCustomComponent: true,
      };
      break;
    case "organization selector":
      component = "OrgExperienceInputs";
      props = {
        ...props,
        isCustomComponent: true,
      };
      break;
  }

  return { component, ...props };
};

export default mapQuestionTypeToComponentAndProps;
